//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import html2canvas from "html2canvas";
import axios from "axios";

export default {
  data() {
    return {
      buildingObj:{},
      // imgUrl: require("../assets/house.jpg"),
      imgUrl:'',
      labelList:[],
      labelListShow:[],
      height:`${window.outerHeight*0.56}`,
      width:1200,

        // 所有标签数据
      totalPage: [],
      // 每页显示标签数据
      pageSize: 5,
      // 共几页
      pageNum: 1,
      // 默认当前显示第一页
      currentPage: 0,
      isChange:true
      // num:0,
      // num:0,
    };
  },
  props: {
    buildingBean: Object,
    domainContextUrl:String,
    isSave:Boolean,
    model: Object,
    getNameSpace: Function,
    invoke: Function,
    baseUrl:String,
    fId:String,
    appId:String,
    isSaveAndPrint:Boolean,
    opResult:Boolean,
    isOpResult:Boolean
  },
  watch:{
     buildingBean:{
       handler:function(newval,oldval){
            console.log('初始化数据变动')
                this.buildingObj=this.cloneDeepJson(this.buildingBean)
                if(this.buildingObj.srcImgURL){
                    this.imgUrl=this.model.fileServer+this.buildingObj.srcImgURL
                    let value={
                        imageUrl:this.buildingObj.srcImgURL
                    }
                    let parm={content:{ type:'getImageBase64', value:value}}
                    console.log('图片换base64',parm)
                    this.invoke('invokeCustomEvent',parm) 
                    this.getImgInfo() 
                }
            
            // }
              
       },
       deep: true
     },
    isSave:{
       handler:function(newval,oldval){
           if(this.isSave){
              console.log('调用保存',this.isSave)
              //生成图片
              this.saveDataApi()
              this.isSave=false
           }
       },
       deep: true
    },
    isSaveAndPrint:{
       handler:function(newval,oldval){
           if(this.isSaveAndPrint){
              console.log('调用保存并打印',this.isSaveAndPrint)
              //
              //  判断是否生成
              this.saveDataBefore()
              this.isSaveAndPrint=false
           }
       },
       deep: true
    },
     isOpResult:{
       handler:function(newval,oldval){
          if(this.isOpResult){
             console.log('调用弹框',this.isOpResult)
            if(this.opResult){
              console.log('弹框后',this.opResult)
              //确认保存且生成图片 
              this.saveImg(this.model.pageId+'mycanvas')
           }else{
             //复原后保存且生成图片
             //复原
              this.isChange=false
              console.log('拒绝',this.opResult)
               //把比率转回正常值
            // this.buildingObj.sourceHouseProjectShowBuildBeanList.forEach(element => {
            //   if(element.label){
            //     element.positionX=element.positionX*this.width
            //     element.positionY=element.positionY*this.height
            //   }
            // });
            // console.log('转化后',this.width,this.buildingObj.sourceHouseProjectShowBuildBeanList)
             let temp=this.cloneDeepJson(this.buildingObj)//深拷贝，保留原始数组数据
            // if(!oldval.buildingObj||!this.compareArr(newval.buildingObj.sourceHouseProjectShowBuildBeanList,oldval.buildingObj.sourceHouseProjectShowBuildBeanList)){
              this.pageSize=parseInt(this.height/35)*2;//一页放的数量
              this.pageNum=Math.ceil(temp.sourceHouseProjectShowBuildBeanList.length/this.pageSize)//一共多少页
              for (let i = 0; i < this.pageNum; i++) {
                    // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                    // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                    this.totalPage[i] = temp.sourceHouseProjectShowBuildBeanList.slice(this.pageSize * i,this.pageSize * (i + 1))
                }
                console.log('复原数据',this.totalPage)
                setTimeout(()=>{
                   this.isChange=true
                   this.$nextTick(()=>{
                     this.saveImg(this.model.pageId+'mycanvas')
                   })
                   
                },0)
                
              //保存且生成图片
              // window.location.reload()
            //  
           }
           this.isOpResult=false
          }
           
       },
       deep: true
    },
    baseUrl:{
       handler:function(newval,oldval){
           if(this.baseUrl){
             console.log('图片路径',this.baseUrl)
             this.imgUrl='data:image/png;base64,'+this.baseUrl
             
           }
       },
       deep: true
     },
     
  },
  created() {
     this.handleToNextStep()
  },
  methods: {
  //初始化数据
   initData(){
         //把比率转回正常值
            this.buildingObj.sourceHouseProjectShowBuildBeanList.forEach(element => {
              if(element.label){
                element.positionX=element.positionX*this.width
                element.positionY=element.positionY*this.height
              }
            });
            console.log('转化后',this.width,this.buildingObj.sourceHouseProjectShowBuildBeanList)
            let temp=this.cloneDeepJson(this.buildingObj)//深拷贝，保留原始数组数据

            // if(!oldval.buildingObj||!this.compareArr(newval.buildingObj.sourceHouseProjectShowBuildBeanList,oldval.buildingObj.sourceHouseProjectShowBuildBeanList)){
              this.pageSize=parseInt(this.height/35)*2;//一页放的数量
              this.pageNum=Math.ceil(temp.sourceHouseProjectShowBuildBeanList.length/this.pageSize)//一共多少页
              for (let i = 0; i < this.pageNum; i++) {
                    // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                    // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                    this.totalPage[i] = temp.sourceHouseProjectShowBuildBeanList.slice(this.pageSize * i,this.pageSize * (i + 1))
          
                }
                console.log('总数据',temp.sourceHouseProjectShowBuildBeanList)
   },
   handleToNextStep: function () {
      console.log('初始化页面数据')
      this.invoke('invokeCustomEvent',{content:{ type: 'shcprojectshow_init_data', value:''}})
    },
    // 上一页和下一页
    // 下一页
    nextPage() {
      if (this.currentPage === this.pageNum - 1) return ;
        this.currentPage++
    },
    // 上一页
    prePage() {
      if (this.currentPage === 0) return ;
        this.currentPage--
    },
   cloneDeepJson(obj){
      return JSON.parse(JSON.stringify(obj))
    },
     /**
     * 获取图片的真实宽高
    * @param {Image} img 
    * @param {function} callback 为了兼容旧浏览器，只能采用回调的方式得到真实的 width 和 height
    */
    getImageRealSize(img, callback) {
      if (img.naturalWidth) { // 如果支持HTML5属性，直接使用
        callback(img.naturalWidth, img.naturalHeight);
      } else {
        // 新建一个图片副本，来获取原始宽高
        var copy = new Image();
        copy.onload = function () {
          callback(copy.width, copy.height);
        };
        copy.src = img.src;
      }
    },
    //根据图片大小设置画布
    getImgInfo () {
      let img = new Image()
      img.src = this.imgUrl
      this.height=window.outerHeight*0.56;
      this.width=1200;
      this.getImageRealSize(img,(width,height)=>{
         console.log('真实的图片大小',width,height)
           console.log('还没变的画布大小',this.height,this.width)
         if(width/height>this.width/this.height){
            this.height=(height*this.width)/width
          }else{
            this.width=(this.height*width)/height
          }
          this.initData()
          console.log('图片大小，画布大小：',width,height,this.height,this.width)
      })
    },
      uploadInitImg(){
         console.log('点击上传图片')
        this.invoke('invokeCustomEvent',{content:{ type: 'shcprojectshow_push_project_picture', value:''}})
      },
     getColorStyle(i){
      let backColor='background-color:'+i.color+';';    
      let style=backColor;
      return style
    },
    getStyle(i,num,n){
       let left='';
      let top='';
      let backColor='background-color:'+i.color+';';
      if(i.label){
        left='left:'+ i.positionX+'px;';
        top='top:'+ i.positionY+'px;opacity:1;';
      }else if(!i.label&&this.currentPage==num){ 
        let num=parseInt(this.height/35);//一列放的数量
        let wn=parseInt(n/num);//第几列
        let hn=parseInt(n%num);//第几行
        left='left:'+(this.width+20+wn*90)+'px;';
        top='top:'+35*hn+'px;opacity:1 !important;';
      }else{
        left=''
        top='opacity:0;'
      }
      
      let style=left+top+backColor;
      return style
    },
    getBg(url) {
       let bg ='';
       let style=''
      
      // if(url){
        // bg =
        // "background:url(" +
        // url +
        // ") no-repeat center;background-size: contain;"
        style="height:"+this.height+"px;width:"+this.width+"px;";
      // }
      
      return bg+style;
    },
    getBgBox(){
       let style=''
        style="width:"+(this.width+20)+"px;";
      return style;
    },
    /**
     * 将页面指定节点内容转为图片
     * 1.拿到想要转换为图片的内容节点DOM；
     * 2.转换，拿到转换后的canvas
     * 3.转换为图片
     */
    saveImg(val) {
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // 先获取你要转换为img的dom节点
        var node = document.getElementById(val); //传入的id名称
        console.log("node", node);
        var width = node.offsetWidth; //dom宽
        var height = node.offsetHeight; //dom高
        var scale = 2; //放大倍数 这个相当于清晰度 调大一点更清晰一点
        html2canvas(node, {
          width: width,
          heigth: height,
          backgroundColor: "#ffffff", //背景颜色 为null是透明
          dpi: window.devicePixelRatio * 2, //按屏幕像素比增加像素
          scale: scale,
          X: 0,
          Y: 0,
          scrollX: -3, //如果左边多个白边 设置该偏移-3 或者更多
          scrollY: 0,
          useCORS: true, //是否使用CORS从服务器加载图像 !!!
         allowTaint: true, //是否允许跨域图像污染画布  !!!
        }).then((canvas) => {
            console.log("路径", canvas.toDataURL());
            var url = canvas.toDataURL(); //这里上面不设值cors会报错
              var a = document.createElement("a");//创建一个a标签 用来下载
              a.download = "营销图"; //设置下载的图片名称
              var event = new MouseEvent("click");//增加一个点击事件
              a.href = url;//此处的url为base64格式的图片资源
              a.dispatchEvent(event); //触发a的单击事件 即可完成下载
             this.uploadImg(url);
        });
    
    },
    /**
     * base64ToFile base64转文件
     * @param {String} urlData base64编码参数
     */
    base64ToFile(baseData, filename) {
      let arr = baseData.split(",");
      let type = arr[0].match(/:(.*?);/)[1]; // 解锁图片类型
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let bufferArray = new Uint8Array(n);
      while (n--) {
        bufferArray[n] = bytes.charCodeAt(n);
      }
      return new File([bufferArray], filename, { type: type });
    },
    //上传图片
    uploadImg(baseData) {
      let file = this.base64ToFile(baseData, "file" + Date.now() + ".png");
      let param = new FormData();
      param.append("file", file);
      param.append("fId", this.fId);
      param.append("appId",this.appId);
      let date = new Date();
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let url=Y+M+'/'+this.appId+'/'+this.fId+'/images/file'+ + Date.now() + '.png'
      param.append(
        "url",url
      );
      console.log("上传图片参数：", param);
      let config = {
        headers: { "Content-Type": "multipart/form-data;boundary=boundary" },
      };
      axios
        .post(this.domainContextUrl+"/image/uploadImage.do", param, config)
        .then((response) => {
            console.log('图片上传后返回的结果：',response.data);
            this.saveDataPrintApi(response.data.url)
        });
    },
    saveDataBefore(){
       //二维数组转一维
        let tempList = []
        if( this.totalPage != undefined ||  this.totalPage.length > 0){
            tempList = [].concat.apply([], this.totalPage);
        }
       //打印需要比较
          let flag = this.compareArr(tempList,this.buildingObj.sourceHouseProjectShowBuildBeanList)
          console.log('打印比较',flag)
          console.log('新数据',tempList)
          console.log('原来数据',this.buildingObj.sourceHouseProjectShowBuildBeanList)
          if(!flag){
            //数组不一样，弹框提示
              let value={
              }
              // this.buildingObj.sourceHouseProjectShowBuildBeanList
              let parm={content:{ type:'shcprojectshow_user_changed_record', value:value}}
              console.log('打印弹框提示',parm)
              this.invoke('invokeCustomEvent',parm)
          }else{
            //数组一样，打印
             this.saveImg(this.model.pageId+'mycanvas')
          }
       
    },
    //保存设置
    saveDataApi(){
           console.log('标签总数据',this.totalPage)
            let totalPageTemp=this.cloneDeepJson(this.totalPage)
            let tempList = []
            if( totalPageTemp != undefined ||  totalPageTemp.length > 0){
                tempList = [].concat.apply([], totalPageTemp);
            }
            tempList.forEach(element => {
              if(element.label){
                element.positionX=element.positionX/this.width
                element.positionY=element.positionY/this.height
              }
            });
            let value={
              labelImgURL:'',
              sourceHouseProjectShowBuildBeanList:tempList
            }
            // this.buildingObj.sourceHouseProjectShowBuildBeanList
            let parm={content:{ type:'shcprojectshow_save_data', value:value}}
            console.log('保存设置上传数据',parm)
            this.invoke('invokeCustomEvent',parm) 
    },
     saveDataPrintApi(url=''){
            console.log('标签总数据',this.totalPage)
            let totalPageTemp=this.cloneDeepJson(this.totalPage)
            let tempList = []
            if( totalPageTemp != undefined ||  totalPageTemp.length > 0){
                tempList = [].concat.apply([], totalPageTemp);
            }
            tempList.forEach(element => {
              if(element.label){
                element.positionX=element.positionX/this.width
                element.positionY=element.positionY/this.height
              }
            });
            let value={
            labelImgURL:url,
            sourceHouseProjectShowBuildBeanList:tempList
            }
            // this.buildingObj.sourceHouseProjectShowBuildBeanList
            let parm={content:{ type:'shcprojectshow_save_data_and_print', value:value}}
            console.log('打印上传数据',parm)
            this.invoke('invokeCustomEvent',parm) 
    },
    compareArr(arr1,arr2) {
      if(! arr1 instanceof Array || !arr2 instanceof Array){
        return true; 
      }
      if(arr1.length!= arr2.length){return false;}
      let arr1Str=JSON.stringify(arr1);
      for (let i = 0; i < arr2.length; i++) {
              if(arr1Str.indexOf(JSON.stringify(arr2[i]))==-1){
                  return false;
              }
        }
        return true;
    },
    move(e,num,n) {
      let odiv = e.target; //获取目标元素
       if(!this.buildingObj.edit){
         return
       }
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      let disW =odiv.offsetWidth
      let disH =odiv.offsetHeight
      // console.log(disW,disH,'宽高')
      let oldX=0;
      let oldY= 0;
      let opacity=1
      if(this.currentPage==num){ 
        let num=parseInt(this.height/35);//一列放的数量
        let wn=parseInt(n/num);//第几列
        let hn=parseInt(n%num);//第几行
        oldX= this.width+20+wn*90;
        oldY=35*hn
      }else{
         opacity=0
      }

      // let oldX= odiv.offsetLeft
      // let oldY= odiv.offsetTop
      
      document.onmousemove = (e) => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
       this.totalPage[num][n].positionX = left;
       this.totalPage[num][n].positionY = top;
        // console.log(left, top, "位置");
        //移动当前元素
        // odiv.style.right='auto'
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = (e) => {
        console.log('移动后位置：',this.totalPage[num][n].positionX,this.totalPage[num][n].positionY);
        let positionX=this.totalPage[num][n].positionX;
        let positionY=this.totalPage[num][n].positionY;
       this.totalPage[num][n].label=true

        if(positionX<0||positionX>this.width-disW){
           console.log('宽度不合格')
          this.totalPage[num][n].positionX = oldX;
          this.totalPage[num][n].positionY = oldY;
          this.totalPage[num][n].label=false
          //  if(this.totalPage[num][n].showLabel==0){
          //    this.showLabelnum++;
          //   this.totalPage[num][n].showLabel= this.showLabelnum;
          //  }
           
            // odiv.style.right='auto'
            odiv.style.left = oldX + "px";
            odiv.style.top = oldY + "px";
            odiv.style.opacity = opacity
        }
        if(positionY<0||positionY>this.height-disH){
           console.log('高度不合格')
          this.totalPage[num][n].positionX = oldX;
          this.totalPage[num][n].positionY = oldY;
          this.totalPage[num][n].label=false
          
          //  if(this.totalPage[num][n].showLabel==0){
          //    this.showLabelnum++;
          //   this.totalPage[num][n].showLabel= this.showLabelnum;
          //  }
          //  odiv.style.right='auto'
           odiv.style.left = oldX + "px";
           odiv.style.top = oldY + "px";
           odiv.style.opacity = opacity
        }

       
        // label
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
};
